import { ProcessingDetails } from '@/api/content/connector'

export type ProcessingDetailsDisplay = {
  label: string
  colourClass: string
}

export function processingDetailsDisplay(details: ProcessingDetails | undefined): ProcessingDetailsDisplay | null {
  switch (details) {
    case ProcessingDetails.PdfNoText:
      return { label: 'No text found in PDF', colourClass: 'text-warning' }
    case ProcessingDetails.EmptyFolder:
      return { label: 'Empty folder', colourClass: 'text-warning' }
    case ProcessingDetails.FileCorrupt:
      return { label: 'File appears corrupt', colourClass: 'text-destructive' }
    case ProcessingDetails.FileTooLarge:
      return { label: 'File too large', colourClass: 'text-destructive' }
    case ProcessingDetails.UnsupportedType:
      return { label: 'Unsupported file type', colourClass: 'text-destructive' }
    case ProcessingDetails.SourceMissing:
      return { label: 'Source file missing', colourClass: 'text-destructive' }
    case ProcessingDetails.ExtractionTimeout:
      return { label: 'Processing limit reached', colourClass: 'text-destructive' }
    case ProcessingDetails.TreeCycle:
      return { label: 'Invalid cyclic folder structure', colourClass: 'text-destructive' }
    case ProcessingDetails.None:
    default:
      return null
  }
}
